import React, { Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import App from './App'
import GlobalStyle from './style/global'
import { getRouterBasename } from './utils/routerBasename'

const Root = () => {
  const basename = getRouterBasename()

  return (
    <React.StrictMode>
      <Router basename={basename}>
        <GlobalStyle />
        <Suspense fallback="loading...">
          <Routes>
            <Route path="/figma" element={<App isFigma />} />
            <Route path="/" element={<App isFigma={false} />} />
          </Routes>
        </Suspense>
      </Router>
    </React.StrictMode>
  )
}

export default Root
